import { FC, ReactNode } from 'react';
import styles from './PunchupPageHeader.module.css';

interface PunchupPageHeaderProps {
	title: string;
	description: string;
	/**
	 * Optional right-aligned slot for page-level actions (refresh, download, send,
	 * custom CTA). Rendered inside an actions container so the row supports
	 * flex-wrap: when title + actions don't fit on a single line, the actions
	 * group wraps to a second line right-aligned beneath the title block. Pass
	 * raw ReactNode (one or more buttons or a Fragment); the wrapper handles
	 * spacing.
	 */
	actions?: ReactNode;
}

export const PunchupPageHeader: FC<PunchupPageHeaderProps> = ({ title, description, actions }) => (
	<div className={styles.root}>
		<div className={styles.text}>
			<h2 className={styles.title}>{title}</h2>
			<p className={styles.description}>{description}</p>
		</div>
		{actions && <div className={styles.actions}>{actions}</div>}
	</div>
);
